module.exports = __webpack_public_path__ + "static/media/cures.651986a5.mp3";